<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :inline="true">
          <el-form-item>
            <el-button v-if="isSuperAuthority" type="primary" icon="el-icon-plus" size="mini" @click="handleAdd" style="background-color: #3CA757; border-color: #3CA757;">新增服务商</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="configList" border stripe>
        <el-table-column label="序号" type="index" align="center" width="60" />
        <el-table-column label="服务商名称" align="center" prop="spName" />
        <el-table-column label="服务商商户号" align="center" prop="spMchId" />
        <el-table-column label="服务商AppID" align="center" prop="spAppId" />
        <el-table-column label="商户序列号" align="center" prop="spMerchantSerialNumber" width="200px" />
        <el-table-column label="私钥路径" align="center" prop="spPrivateKeyPath" width="200px" />
        <el-table-column label="是否启用" align="center" prop="isActive">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isActive === 1 ? '#67C23A' : '#F56C6C' }">{{ scope.row.isActive === 1 ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否默认" align="center" prop="isDefault">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isDefault === 1 ? '#67C23A' : '#909399' }">{{ scope.row.isDefault === 1 ? '默认' : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="160px" />
        <el-table-column v-if="isSuperAuthority" label="操作" align="center" width="180px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body @close="handleDialogClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="服务商名称" prop="spName">
          <el-input v-model="form.spName" placeholder="请输入服务商名称，如：友信智联" />
        </el-form-item>
        <el-form-item label="服务商商户号" prop="spMchId">
          <el-input v-model="form.spMchId" placeholder="请输入服务商商户号" />
        </el-form-item>
        <el-form-item label="服务商AppID" prop="spAppId">
          <el-input v-model="form.spAppId" placeholder="请输入服务商AppID" />
        </el-form-item>
        <el-form-item label="API V3密钥" prop="spApiV3Key">
          <el-input v-model="form.spApiV3Key" type="password" placeholder="请输入API V3密钥" show-password />
        </el-form-item>
        <el-form-item label="商户序列号" prop="spMerchantSerialNumber">
          <el-input v-model="form.spMerchantSerialNumber" placeholder="请输入商户序列号" />
        </el-form-item>
        <el-form-item label="私钥文件路径" prop="spPrivateKeyPath">
          <el-input v-model="form.spPrivateKeyPath" placeholder="请输入私钥文件路径，如：/opt/project/cert/apiclient_key.pem" />
        </el-form-item>
        <el-form-item label="微信支付公钥ID" prop="spWechatPayPublicKeyId">
          <el-input v-model="form.spWechatPayPublicKeyId" placeholder="请输入微信支付公钥ID" />
        </el-form-item>
        <el-form-item label="微信支付公钥路径" prop="spWechatPayPublicKeyPath">
          <el-input v-model="form.spWechatPayPublicKeyPath" placeholder="请输入微信支付公钥路径，如：/opt/project/cert/pub_key.pem" />
        </el-form-item>
        <el-form-item label="是否启用" prop="isActive">
          <el-radio-group v-model="form.isActive">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否默认" prop="isDefault">
          <el-radio-group v-model="form.isDefault">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm" style="background-color: #3CA757; border-color: #3CA757;">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SpPaymentConfigManage",
  data() {
    return {
      loading: true,
      configList: [],
      isSuperAuthority: false,
      title: "",
      open: false,
      form: {},
      rules: {
        spName: [{ required: true, message: "服务商名称不能为空", trigger: "blur" }],
        spMchId: [{ required: true, message: "服务商商户号不能为空", trigger: "blur" }],
        spAppId: [{ required: true, message: "服务商AppID不能为空", trigger: "blur" }],
        spApiV3Key: [{ required: true, message: "API V3密钥不能为空", trigger: "blur" }],
        spMerchantSerialNumber: [{ required: true, message: "商户序列号不能为空", trigger: "blur" }],
        spPrivateKeyPath: [{ required: true, message: "私钥文件路径不能为空", trigger: "blur" }],
        spWechatPayPublicKeyId: [{ required: true, message: "微信支付公钥ID不能为空", trigger: "blur" }],
        spWechatPayPublicKeyPath: [{ required: true, message: "微信支付公钥路径不能为空", trigger: "blur" }],
        isActive: [{ required: true, message: "是否启用不能为空", trigger: "change" }],
        isDefault: [{ required: true, message: "是否默认不能为空", trigger: "change" }]
      }
    };
  },
  created() {
    this.getList();
    this.initCurrentRoleCode();
  },
  methods: {
    initCurrentRoleCode() {
      const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]');
      const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]');
      this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY');
    },
    getList() {
      this.loading = true;
      this.$http.get('/sp/payment/config/list').then(response => {
        if (response.data.code === 200) {
          this.configList = response.data.data;
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    reset() {
      this.form = {
        id: null,
        spName: null,
        spMchId: null,
        spAppId: null,
        spApiV3Key: null,
        spMerchantSerialNumber: null,
        spPrivateKeyPath: null,
        spWechatPayPublicKeyId: null,
        spWechatPayPublicKeyPath: null,
        isActive: 1,
        isDefault: 0
      };
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    },
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "新增服务商配置";
    },
    handleUpdate(row) {
      this.reset();
      this.$http.get('/sp/payment/config/' + row.id).then(response => {
        if (response.data.code === 200) {
          this.form = response.data.data;
          this.open = true;
          this.title = "修改服务商配置";
        } else {
          this.$message.error(response.data.msg || '获取数据失败');
        }
      }).catch(() => {
        this.$message.error('获取数据失败');
      });
    },
    handleDelete(row) {
      this.$confirm('确认删除该服务商配置？删除后关联的商户将回退到默认服务商', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.get('/sp/payment/config/delete/' + row.id);
      }).then(response => {
        if (response.data.code === 200) {
          this.getList();
          this.$message.success("删除成功");
        } else {
          this.$message.error(response.data.msg || '删除失败');
        }
      }).catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const url = this.form.id ? '/sp/payment/config/update' : '/sp/payment/config/add';
        this.$http.post(url, this.form).then(response => {
          if (response.data.code === 200) {
            this.$message.success(this.form.id ? "修改成功" : "新增成功");
            this.open = false;
            this.getList();
          } else {
            this.$message.error(response.data.msg || '操作失败');
          }
        }).catch(() => {
          this.$message.error('操作失败');
        });
      });
    },
    handleDialogClose() {
      this.reset();
    }
  }
};
</script>
